import React, { useState, useCallback } from 'react';
import Sidebar from '../components/Navbars/Sidebar'
import HeaderNavbar from '../components/Navbars/HeaderNavbar'
import Header from '../components/Header/Header';

import { Container } from 'reactstrap';

const Layout = (props) => {
    const { childComponent: Component, routes, pageName, path, ...rest } = props;
    const [headerContent, setHeaderContent] = useState(null);
    const setHeader = useCallback(content => {
        setHeaderContent(content);
    }, []);

    return (
        <>
            <Sidebar
                logo={{
                    innerLink: "/",
                    imgSrc: "",
                    imgAlt: "...",
                }}
                routes={routes}
            />
            <div className="main-content">
                <HeaderNavbar
                    pageName={pageName}
                    path={path}
                />
                <Header>
                    {headerContent}
                </Header>
                <Container fluid className={"mt--6"}>
                    {Component && <Component onSetHeader={setHeader} {...rest} />}
                </Container>
            </div>
        </>
    );
}
export default Layout;

